import { useSelector } from "react-redux";

const Footer = () => {
    const { userDetail } = useSelector((state) => state.login);
    return (
        <footer className="footer">
            <div className="footer-content">
                <p>&copy; {new Date().getFullYear()} {userDetail?.tenantId?.tenant_name || "Trangile"}. All rights reserved.</p>
            </div>
        </footer>
    );
}

export default Footer;